import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/screens/contacts/ContactsPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/alarm.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/arrow_right.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/bell.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/cart_empty.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/checkmark.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/chervon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/cross_big.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/cross_small.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/download.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/eye_closed.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/eye_open.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/fullStory.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/Info.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/leave.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/like_empty.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/like_favorites.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/like_filled.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/menu.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/minus_big.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/minus_small.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/plus_big.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/plus_small.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/search.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/simpleStory.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/sorting_down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/sorting_up.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/user.svg");
;
import(/* webpackMode: "eager", webpackExports: ["usePhoneMask"] */ "/app/src/shared/lib/hooks/usePhoneMask.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useProductFilters"] */ "/app/src/shared/lib/hooks/useProductFilters.ts");
;
import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/app/src/shared/ui/backButton/BackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Checkbox"] */ "/app/src/shared/ui/checkbox/Checkbox.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/contacts/ui/phone/phone.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/contacts/ui/email/email.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/contacts/ui/copyright/copyright.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/burger/burger.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/bullet/bullet.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/downloadButton/downloadButton.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Dropdown"] */ "/app/src/shared/ui/dropdown/Dropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Filter"] */ "/app/src/shared/ui/filter/Filter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HydratedPage"] */ "/app/src/shared/ui/hydratedPage/HydratedPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Input"] */ "/app/src/shared/ui/input/Input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/app/src/shared/ui/logo/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalSlider"] */ "/app/src/shared/ui/modalSlider/ModalSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/shared/ui/pagination/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/scrollTop/scrollTop.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/shopLocation/shopLocation.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/queryStatus/queryStatus.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/breadcrumbs/breadCrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/entities/seo/ui/serverBreadcrumbs.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/app/src/shared/ui/slider/Slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderNavigation"] */ "/app/src/shared/ui/sliderNavigation/SliderNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sorting"] */ "/app/src/shared/ui/sorting/Sorting.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/sticker/sticker.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/tabs/tabs.module.scss");
